import {
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output
} from '@angular/core';
import ResizeObserver from 'resize-observer-polyfill'; // not needed really since > Chrome 64

const entriesMap = new WeakMap();

const ro = new ResizeObserver(entries => {
  for (const entry of entries) {
    if (entriesMap.has(entry.target)) {
      const comp = entriesMap.get(entry.target);
      comp._resizeCallback(entry);
    }
  }
});

@Directive({
  selector: '[csResize]',
  standalone: false
})
export class ResizeDirective implements OnDestroy {
  @Output()
  public sizeChanged = new EventEmitter();
  @Input()
  public startEmit = false;

  constructor(private el: ElementRef<HTMLElement>) {
    const target = this.el.nativeElement;
    entriesMap.set(target, this);
    ro.observe(target);
  }

  public _resizeCallback(entry: ResizeObserverEntry): void {
    if (this.startEmit) {
      this.sizeChanged.emit(entry);
    }
  }

  public ngOnDestroy(): void {
    const target = this.el.nativeElement;
    ro.unobserve(target);
    entriesMap.delete(target);
  }
}
